module.exports = __webpack_public_path__ + "img/r.539cfd59.jpg";